import { render, staticRenderFns } from "./SalaryPaymentView.vue?vue&type=template&id=3ddbac9a&"
import script from "./SalaryPaymentView.vue?vue&type=script&lang=js&"
export * from "./SalaryPaymentView.vue?vue&type=script&lang=js&"
import style0 from "./SalaryPaymentView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports